import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, watch} from "vue";
import {QuestionEntry, RawAnswer} from "@/lib/QuestionHandler";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextQuestion',
  props: {
    modelValue: {},
    question: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const value = ref<string>('')

watch(value, () => emit("update:modelValue", value.value), { immediate: true })

watch(() => props.question, () => {
  value.value = (props.question.userQuestion ? props.question.userQuestion.stringValue : '') || ''
}, { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    rows: "5",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
  }, null, 512)), [
    [_vModelText, value.value]
  ])
}
}

})